import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { GenericResponse } from '../business-entities/generic-response';
import { PickDropCustomer } from '../business-entities/pick-drop-customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerDropPickService {

  constructor(private dataProvider : DataService) { }

  async getCustomerPickDropList(data):Promise<GenericResponse<Array<PickDropCustomer>>>{
    return this.dataProvider.Post<GenericResponse<Array<PickDropCustomer>>>(Urls.GetCustomerPickDropList,data).toPromise();
  }
}
